import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';
import { mapPowerUpId as MAP_POWER_UP_ID } from '@trello/config';
//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class BoardPlugin extends TrelloModel {
  static initClass() {
    // @ts-ignore
    this.prototype.typeName = 'BoardPlugin';
  }

  isButler(): boolean {
    return this.get('idPlugin') === BUTLER_POWER_UP_ID;
  }

  isMap(): boolean {
    return this.get('idPlugin') === MAP_POWER_UP_ID;
  }
}
BoardPlugin.initClass();

export { BoardPlugin };
